import { PLANET_ORDER } from '../constants.js';
import {
  clearElement,
  enrichPlanetList,
  formatDegreeInSign,
  formatDegrees,
  htmlElement,
  safeText,
} from '../utils.js';

export function renderPositionTables(container, snapshot) {
  clearElement(container);
  const layout = htmlElement('div', { className: 'positions-layout' });
  layout.append(
    buildPositionTable('Birth chart', snapshot?.natal?.planets || []),
    buildPositionTable('Gochar (transits)', snapshot?.transit?.planets || []),
  );
  container.append(layout);
  return layout;
}

function buildPositionTable(title, list) {
  const planets = enrichPlanetList(list).sort((a, b) => {
    const left = PLANET_ORDER.indexOf(a.id);
    const right = PLANET_ORDER.indexOf(b.id);
    return (left < 0 ? 99 : left) - (right < 0 ? 99 : right);
  });
  const section = htmlElement('section', { className: 'position-table-card' });
  section.append(htmlElement('h3', { text: title }));
  const table = htmlElement('table', { className: 'aat-data-table' });
  const head = htmlElement('thead');
  head.append(htmlElement('tr', {}, [
    htmlElement('th', { text: 'Planet' }),
    htmlElement('th', { text: 'Longitude' }),
    htmlElement('th', { text: 'Rashi' }),
    htmlElement('th', { text: 'Nakshatra' }),
    htmlElement('th', { text: 'Pada' }),
    htmlElement('th', { text: 'Speed' }),
    htmlElement('th', { text: 'State' }),
    htmlElement('th', { text: 'House' }),
    htmlElement('th', { text: 'Dignity' }),
  ]));
  const body = htmlElement('tbody');
  planets.forEach((planet) => {
    body.append(htmlElement('tr', {}, [
      htmlElement('td', {}, [
        htmlElement('span', { className: `table-planet ${planet.className || 'planet-generic'}`, text: planet.short }),
        ` ${planet.name}`,
      ]),
      htmlElement('td', { text: formatDegrees(planet.longitude, { includeSeconds: true }) }),
      htmlElement('td', { text: `${formatDegreeInSign(planet.degreeInSign)} ${planet.sign}` }),
      htmlElement('td', { text: safeText(planet.nakshatra) }),
      htmlElement('td', { text: safeText(planet.pada) }),
      htmlElement('td', { text: Number.isFinite(planet.speed) ? `${planet.speed.toFixed(4)}°/day` : '—' }),
      htmlElement('td', { text: planet.retrograde ? 'Retrograde' : 'Direct' }),
      htmlElement('td', { text: safeText(planet.house) }),
      htmlElement('td', { text: safeText(planet.dignity) }),
    ]));
  });
  table.append(head, body);
  section.append(table);
  return section;
}
